<i18n>
{
  "pe": {
    "SIMULATION": "Simulación",
    "DOCUMENTS": "Documentos",
    "APPROVAL": "Aprobación",
    "LEGAL_ANALYSIS": "Análisis Jurídico",
    "CONTRACT": "Contrato",
    "YOUR_HOME": "Tu casa"
  },
  "cl": {
    "SIMULATION": "Simulación",
    "DOCUMENTS": "Documentos",
    "APPROVAL": "Aprobación",
    "LEGAL_ANALYSIS": "Análisis Jurídico",
    "CONTRACT": "Contrato",
    "YOUR_HOME": "Tu casa"
  },
  "br": {
    "SIMULATION": "Simulação",
    "DOCUMENTS": "Documentos",
    "APPROVAL": "Aprovação",
    "LEGAL_ANALYSIS": "Análise Jurídica",
    "CONTRACT": "Contrato",
    "YOUR_HOME": "Sua casa"
  }
}
</i18n>
<template>
  <div id="client-timeline" class="card-item">
    <section class="columns is-vcentered">
      <div class="column has-text-centered is-hidden-tablet is-hidden-desktop pt-0 pb-1">
        <span class="current-step">{{ $t(steps[activeStep].name) }}</span>
      </div>
      <div class="column pt-1">
        <b-steps
          v-model="activeStep"
          :animated="isAnimated"
          :rounded="isRounded"
          :has-navigation="hasNavigation"
          :label-position="labelPosition"
          :mobile-mode="mobileMode">
          <b-step-item
            v-for="step in steps"
            :key="step.name"
            :label="$t(step.name)"
            :clickable="clickable"
            :type="{'is-success': step.status}"
            icon-pack="fas"
            :icon="icon(step)" />
        </b-steps>
      </div>
    </section>
  </div>
</template>

<script>
import { ProspectsClient } from '@/application/services/api-clients/prospects-client';
import { simulatorBackend } from '@/application/api';
import { Headers } from '@/application/services/api-clients/headers';
import { IdMaker } from '@/application/services/utils/id-maker';
import notification from '@/ui/mixins/notification';

const defaultState = [
  { name: 'SIMULATION', status: true },
  { name: 'DOCUMENTS', status: false },
  { name: 'APPROVAL', status: false },
  { name: 'LEGAL_ANALYSIS', status: false },
  { name: 'CONTRACT', status: false },
  { name: 'YOUR_HOME', status: false }
];

export default {
  name: 'Timeline',
  mixins: [notification],
  props: {
    prospectId: {
      type: String,
      required: true
    },
    currentUser: {
      type: String
    }
  },
  data() {
    return {
      activeStep: 0,
      isAnimated: false,
      isRounded: true,
      isStepsClickable: false,
      hasNavigation: false,
      labelPosition: 'bottom',
      mobileMode: 'compact',
      clickable: false,
      steps: defaultState,
      current: {
        name: 'Documentos'
      }
    };
  },
  async mounted() {
    const headers = new Headers(this.$route, this.$store, new IdMaker());
    const prospectClient = new ProspectsClient(simulatorBackend, headers);

    try {
      const prospectStatus = await prospectClient.progressStatus(this.prospectId);
      const active = prospectStatus.filter(v => v.position || v.position === 0);
      this.steps = prospectStatus;
      this.activeStep = active[0].position;
      this.$emit('prospectStatus', prospectStatus);
    } catch (reason) {
      this.alert({ message: reason.message });
      this.steps = defaultState;
    }
  },
  methods: {
    icon(step) {
      if (step.name === 'YOUR_HOME') {
        return 'home';
      }
      if (step.status) {
        return 'check';
      }
      return '';
    }
  }
};
</script>

<style>
#client-timeline {
  background-color: #f2fbfb;
  padding: 2.5em 0 1.3em;
  border-radius: 40px;
  margin-bottom: 1.5rem;
}
.b-steps .steps .step-items .step-item.is-success .step-marker,
.b-steps .steps .step-items .step-item.is-active .step-marker{
  border: solid;
  border-color: #00CCD1!important;
}
.b-steps .steps .step-items .step-item .step-link {
  color: #d9d9d9;
}
.b-steps .steps .step-items .step-item.is-active .step-link,
.current-step {
  color: #00CCD1;
}
.b-steps .steps .step-items .step-item.is-success .step-link {
  color: #666;
}
.current-step {
  margin-left: 0.5em;
}
.b-steps .steps .step-items .step-item .step-link:not(.is-clickable) {
  cursor: auto;
}
.b-steps .steps .step-items .step-item .step-details {
  padding-top: 6px;
}
.b-steps .steps .step-items .step-item .step-details .step-title{
  font-weight: normal!important;
  font-size: 1em;
}
.b-steps .steps.is-rounded .step-item .step-marker {
  border: none;
  background-color: #d9d9d9;
}
.b-steps .steps + .step-content {
  display: none;
}
@media screen and (max-width: 769px) {
  .step-details {
    display: none;
  }
  #client-timeline {
    padding: 1.8em 0 1.3em;
  }
}
</style>
